
export default{
    centerSlide:{
        slide:[{
            "name": "采购管理",
            "children": [
                {
                    "name": "采购订单",
                },
            ]
        },
        {
            "name": "客户服务",
            "children": [
                {
                    "name": "退款/售后",
                },
            ]
        },
        {
            "name": "财务",
            "children": [
                {
                    "name": "授信申请",
                },
                {
                    "name": "额度信息",
                },
                {
                    "name": "账期结算单",
                },
                {
                    "name": "未出账单",
                },
                {
                    "name": "发票管理",
                },
                 {
                    "name": "合同管理",
                },
            ]
        },
        {
            "name": "设置",
            "children": [
              {
                    "name": "账户信息",
                },
                {
                    "name": "账户安全",
                },
                {
                    "name": "我的认证",
                },
                
                {
                    "name": "地址管理",
                }
            ]
        },
        {
            "name": "关注中心",
            "children": [
              {
                    "name": "商品收藏",
                },
                {
                    "name": "店铺收藏",
                },
            ]
        }
        ]
    }
    
}